import React, { useRef } from "react";

const MODULES = [
  {
    title: "Secure Door Automation",
    description: "Dual authentication—facial recognition plus weight detection—delivers unbeatable entry security.",
    icon: "🔒"
  },
  {
    title: "Automated Pool Cover",
    description: "Scheduled closures and safety sensors retract instantly to prevent accidents, keeping loved ones safe.",
    icon: "🏊"
  },
  {
    title: "Electrochromic Windows",
    description: "PDLC film lets you adjust tint for privacy and energy efficiency with a single tap.",
    icon: "🪟"
  }
];

export default function Solutions() {
  return (
    <section id="modules" className="py-24 bg-brand-dark">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-gold mb-16">
          Our Integrated Modules
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {MODULES.map(({ title, description, icon }) => (
            <div
              key={title}
              className="relative bg-brand-gray border border-gray-700 rounded-xl p-8 hover:border-gold transition-colors shadow-xl group overflow-hidden"
            >
              {/* Animated Light Sweep */}
              <span className="absolute w-36 h-96 left-[-60px] top-0 pointer-events-none group-hover:animate-sweep bg-gradient-to-r from-gold/30 via-gold/8 to-transparent opacity-80 blur-2xl rotate-12" />
              <div className="w-16 h-16 rounded-full bg-gold flex items-center justify-center text-2xl mb-6 shadow-md">
                {icon}
              </div>
              <h3 className="text-xl font-serif font-bold mb-4">{title}</h3>
              <p className="text-gray-300">{description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
